// extracted by mini-css-extract-plugin
module.exports = {"root":"Stat_root__4UUNV","bottom":"Stat_bottom__N1CQL","top":"Stat_top__GkGQE","parallaxDefault":"Stat_parallaxDefault__mabU5","parallaxOffset":"Stat_parallaxOffset__7mUhD"};